import {
  is_valid_reason,
  trim_reason
} from '../../../util_components/required_reason_textarea/reason_rules';

// which note the "Edit Session Details" save must carry. Pure; apis re-validates all of it.
const flag_on = (x) => parseInt(x, 10) === 1 || x === true;

export function resolve_edit_reason(input) {
  const {
    status,
    original_status,
    cancelled_by_student,
    cancelled_by_teacher,
    original_cancelled_by_student,
    teacher_penalty,
    original_teacher_penalty,
    teacher_penalty_reason,
    status_change_reason
  } = input;

  const status_changed = status !== original_status;
  const p = parseInt(teacher_penalty, 10);
  const penalty_changed = !Number.isNaN(p) && p !== (parseInt(original_teacher_penalty, 10) || 0);
  // The modal opens with both flags off and only sends a CHECKED flag, so only a newly-checked flag counts; a teacher-cancel always submits its request time.
  const attribution_changed =
    status === 'CANCELLED' &&
    ((flag_on(cancelled_by_student) && !flag_on(original_cancelled_by_student)) ||
      flag_on(cancelled_by_teacher));

  const penalty_note = trim_reason(teacher_penalty_reason);
  const own_note = trim_reason(status_change_reason);
  // The penalty note may double as the status note only when the penalty itself changed;
  // attribution-only flips need their own (apis).
  const can_reuse_penalty_note =
    status_changed && !attribution_changed && penalty_changed && penalty_note !== '';
  const reason_required = status_changed || attribution_changed;
  const reason = own_note || (can_reuse_penalty_note ? penalty_note : '');

  return {
    status_changed,
    penalty_changed,
    attribution_changed,
    reason_required,
    show_reason_textarea: reason_required && !can_reuse_penalty_note,
    reason,
    reason_valid: !reason_required || is_valid_reason(reason)
  };
}

export default resolve_edit_reason;
